import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import desktopImageWebp from './images/hero.webp';
import mobileImageWebp from './images/hero-mobile.webp';
// styles
import { FlexibleHeroStyled } from './styles';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';

export default () => {
  return (
    <FlexibleHeroStyled
      sectionId='philanthropy-page-flexible-hero'
      headingText={<>Making a Lasting Impact on the People <WidowBlock>and Communities</WidowBlock></>}
      headingTextPosition='bottom'
      desktopImage={desktopImageWebp.toString()}
      mobileImage={mobileImageWebp.toString()}
      desktopImageLowRes={lowResImageDesktop}
      mobileImageLowRes={lowResImageMobile}
    />
  );
};
